<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    
    <multiselect v-model="selected" :custom-label="getLabel" track-by="_id" :placeholder="$t(placeHolder)"
                 :options="items" :multiple="multiple" :disabled="disabled" :internal-search="false"
                 @input="onInput" @search-change="search">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import _ from 'lodash';
import list from '@/mixins/List';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'domain'
    },
    label: String,
    errors: Array,
    placeHolder: {
      type: String,
      default: 'selectClient'
    },
    multiple: Boolean,
    disabled: Boolean,
    status: String,
    isTrial: String,
    isChatbot: Boolean,
    isTrialOrNotChatbot: Boolean,
    isChatbotNotExpired: Boolean,
  },
  components: {Multiselect},
  mixins: [list],
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'client',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
      },
      focused: false,
      changeTrigger: true,
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    selected(val) {
    this.changeTrigger = false;
    if (val === null) {
      this.model[this.attribute] = val;
    } else if (this.multiple) {
      this.model[this.attribute] = val.map(s => s._id);
    } else {
      this.model[this.attribute] = val._id;
    }
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    onInput() {
      let val = this.selected;
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id);
      } else {
        this.model[this.attribute] = val._id;
      }
      this.$emit('change');
    },
    getLabel({domain, companyName, isTrial}) {
      return `${domain} - ${companyName}` + (isTrial ? ` (${this.$t('isTrial')})` : '');
    },
    search: _.debounce(function (event) {
      this.filterFormModel.keyword = event;
      this.filterFormModel.page = 1;
      this.load();
    }, 250),
    loadSelected() {
      if (this.model[this.attribute]) {
        let ids;
        if (this.multiple) {
          ids = this.model[this.attribute].join(',');
        } else {
          ids = this.model[this.attribute];
        }
        if (ids) {
          this.$bgService.get(this.service, {
            params: {page: 1, pageSize: 100, ids: ids}
          }).then(response => {
            if (this.multiple) {
              this.selected = response.data.docs;
            } else if (response.data.docs.length) {
              let rs = response.data.docs;
              this.selected = rs.find(kq => kq._id === this.model[this.attribute]);
            }
          });
        }
      }
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
    if (this.status) {
      this.filterFormModel.status = this.status
    }
    if (this.isTrial) {
      this.filterFormModel.isTrial = this.isTrial
    }
    if (this.isChatbot) {
      this.filterFormModel.isChatbot = this.isChatbot
    }
    if (this.isTrialOrNotChatbot) {
      this.filterFormModel.isTrialOrNotChatbot = this.isTrialOrNotChatbot
    }
    if (this.isChatbotNotExpired) {
      this.filterFormModel.isChatbotNotExpired = this.isChatbotNotExpired
    }
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectClient: 'Select Client',
      },
      vi: {
        selectClient: 'Chọn khách',
      }
    }
  }
}
</script>